

console.log("Hello world, from the brand folder.")



// WEBPACK FOOTER //
// ./theme/brand/index.js